
import { Component, Vue, Ref } from "vue-property-decorator";

import { getUserIdByTongueReportId } from "@/api/open";

import { getCatchByKey, setCatchByKey } from "@/utils/catch";
import { EnumerateEnum } from "@/enum/enum.enum";

import { phoneMask, nickEncrypt } from "@/utils/common";

import OpenTongueCollectStep1 from "./components/collectStep1.vue";
import OpenTongueCollectStep2 from "./components/collectStep2.vue";
import OpenTongueCollectStep3 from "./components/collectStep3.vue";

const curDomain = `${window.location.origin}`;

@Component({ name: 'open-tongue-collect',
    components: {
        OpenTongueCollectStep1,
        OpenTongueCollectStep2, OpenTongueCollectStep3
    }
})
export default class OpenTongueCollect extends Vue {
    @Ref() OpenTongueCollectStep2!: OpenTongueCollectStep2;
    userInfo: any = {}
    qrCodeUid = "";

    activeStep = 0;

    reportId = "";

    userId = "";

    get reportUrl() {
        const userInfo = getCatchByKey(EnumerateEnum.openTongueUser);
        return `${curDomain}/h5/#/result?id=${this.reportId}&checkId=${this.reportId}&libCode=10001&userId=${userInfo.id}`;
    }

   mounted() {
      this.initCache();
  }

  getGenderDesc() {
    return this.userInfo.gender == 1 ? "男" : "女";
  }

  initCache() {
    const userInfo = getCatchByKey(EnumerateEnum.openTongueUser);
    const qrCodeUid = getCatchByKey(EnumerateEnum.openTongueQrCodeUid);

    if (!qrCodeUid) {
        this.$message.error("二维码信息已过期，请重新扫码使用！");
        this.$router.replace({ path: "/open/open-tongue", query: { deviceCode: "shenzhida22222222" } });
        return
    }

    userInfo && userInfo.phone && (userInfo.phone = phoneMask(userInfo.phone));
    userInfo && userInfo.nickname && (userInfo.nickname = nickEncrypt(userInfo.nickname));
    this.userInfo = userInfo;
    this.qrCodeUid = qrCodeUid;
    console.log(userInfo, qrCodeUid);
  }

  goCheckResult(reportId: string) {
    this.activeStep = 1;
    console.log("reportId", reportId);
    this.reportId = reportId;
    this.$nextTick(() => {
        this.OpenTongueCollectStep2?.startCheckResult();
    });
    
  }

  async goResult() {
    this.activeStep = 3;
    setCatchByKey(EnumerateEnum.openTongueQrCodeUid, "");
    setCatchByKey(EnumerateEnum.openTongueDeviceId, "");
    const win = window.open('', '_blank')

    setTimeout(() => {
        win.location.href = `${curDomain}/#/open/tongue-report?url=${encodeURIComponent(this.reportUrl)}`;
    }, 1000);
  }

  goResultError() {
    this.$confirm("请重新按照“正确姿势”进行拍摄并再重新上传", "舌头照片采集不规范", {
        confirmButtonText: "确定",
        type: "error"
    }).finally(() => {
        this.activeStep = 0;
    });
  }

  restart() {
    setCatchByKey(EnumerateEnum.openTongueUser, {});
    setCatchByKey(EnumerateEnum.openTongueQrCodeUid, "");
    setCatchByKey(EnumerateEnum.openTongueDeviceId, "");
    this.$router.replace({ path: "/open/open-tongue", query: { deviceCode: "shenzhida22222222" } });
  }
}
